module.exports = __webpack_public_path__ + "img/item-cart-nashi-btn01.4621fc5b.png";